import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CommentItem',
};

import { computed, ref, useStore } from '@nuxtjs/composition-api';
import TsLogoSticker from '@/components/svg/TsLogoSticker.vue';
import CommentForm from '@/components/comment/CommentForm.vue';
import { relativeTimeFormat, simpleDate } from '@/utils/formatDate';
import { State } from '@/store';
import { Comment } from '@/types/comment';
interface Props {
  comment: Comment;
  resourceId?: number | null;
  canReply?: boolean;
  level?: number;
}

interface Emits {
  (event: 'add-comment', value: Response): void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    comment: null,
    resourceId: { default: null },
    canReply: { type: Boolean, default: false },
    level: { default: 0 }
  },
  emits: ["add-comment"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'add-comment', value: Response): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { comment: Comment, resourceId: number | null, canReply: boolean, level: number };

const $store = useStore<State>();





const reply = ref<boolean>(false);
const replyingTo = ref<string>(props.comment.user.display_name);

const isAuthenticated = computed(() => $store.getters.isAuthenticated);
const loggedInUser = computed(() => $store.getters.loggedInUser);

const addedComment = (params: any) => {
  if (params.response) {
    emit('add-comment', params.response);
  }
};

const addHyperlinksToModeratorComment = (comment: string) => {
  comment = comment.replace(/(https?:\/\/[^\s,)]+)/g, '<a href="$&">$&</a>');
  return comment;
};

return { __sfc: true,$store, props, emit, reply, replyingTo, isAuthenticated, loggedInUser, addedComment, addHyperlinksToModeratorComment, TsLogoSticker, CommentForm, relativeTimeFormat, simpleDate }
}

})